import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import { Room } from '@/models/RoomModel';
import { featureFlagService } from '@/services/FeatureFlagService';
import { alphabeticalSorter } from '@/utils/SortUtil';

// Constants

export const types = {
  // FETCH COMMUNITY ROOMS
  FETCH_ROOMS_REQUEST: 'FETCH_ROOMS_REQUEST',
  FETCH_ROOMS_SUCCESS: 'FETCH_ROOMS_SUCCESS',
  FETCH_ROOMS_FAILURE: 'FETCH_ROOMS_FAILURE',
  FETCH_ROOMS_ERROR: 'FETCH_ROOMS_ERROR',

  // SET ACTIVE ROOM
  SET_ACTIVE_ROOM: 'SET_ACTIVE_ROOM',
};

const initialState = Immutable({
  rooms: [],
  roomId: '',
  isLoading: false,
  requested: {},
});

// Reducer

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case types.FETCH_ROOMS_REQUEST: {
      return state.merge({
        isLoading: true,
        requested: {
          communityId: action.payload.communityId,
        },
      });
    }
    case types.FETCH_ROOMS_SUCCESS: {
      return state.merge({
        rooms: action.payload.rooms?.sort((a: Room, b: Room) => alphabeticalSorter(a?.name, b?.name)),
        isLoading: false,
      });
    }
    case types.FETCH_ROOMS_FAILURE: {
      return state.merge({
        isLoading: false,
        requested: {},
      });
    }
    case types.SET_ACTIVE_ROOM: {
      featureFlagService.setContextField('roomId', action.payload.roomId);
      return state.roomId != action.payload.roomId ? state.merge({ roomId: action.payload.roomId }) : state;
    }
    default:
      return state;
  }
}

// Actions

export const actions = {
  fetchRoomsRequest: ({ communityId }: { communityId: string }) => ({
    type: types.FETCH_ROOMS_REQUEST,
    payload: { communityId },
  }),
  fetchRoomsSuccess: ({ rooms }: { rooms: Room[] }) => ({
    type: types.FETCH_ROOMS_SUCCESS,
    payload: {
      rooms,
    },
  }),
  fetchRoomsError: ({ error }: { error: string }) => ({
    type: types.FETCH_ROOMS_ERROR,
    payload: {
      error,
    },
  }),
  setActiveRoom: ({ roomId }: { roomId: string }) => ({
    type: types.SET_ACTIVE_ROOM,
    payload: {
      roomId,
    },
  }),
};

// Selectors
const roomsSelector = () => (state: any) => state.rooms;

export const selectRooms = () => createSelector(roomsSelector(), (roomsState: any) => roomsState.rooms);

export const selectActiveRoom = () => createSelector(roomsSelector(), (roomsState: any) => roomsState.roomId);

export const selectIsLoadingRooms = () => createSelector(roomsSelector(), (roomsState: any) => roomsState.isLoading);

export const selectRoomsRequested = () => createSelector(roomsSelector(), (roomsState: any) => roomsState.requested);
